import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled from 'styled-components';
import { color } from '../../../styles/styles.js';
var LabelStyled = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  color: ", ";\n  margin-bottom: 5px;\n  font-weight: bold;\n"], ["\n  display: inline-block;\n  color: ", ";\n  margin-bottom: 5px;\n  font-weight: bold;\n"])), function (props) {
  return props.theme === 'dark' ? color.medium : '#6d6d6d';
});
var templateObject_1;
export { LabelStyled };